import React from 'react';
import { ShieldAlert, Activity, Lightbulb, Users, List } from 'lucide-react';

export const AsrsReportUI = ({ data, meta }) => {
  const s = data.scores || {};
  const isRedAlarm = data.summary?.includes("KIRMIZI");

  const partAStatus = s.partA?.critical >= 4 ? { l: "YÜKSEK RİSKLİ", c: "text-red-700", bg: "bg-red-500", p: 100 } 
                    : s.partA?.critical === 3 ? { l: "KLİNİK SINIRDA", c: "text-amber-600", bg: "bg-amber-400", p: 70 }
                    : { l: "DÜŞÜK RİSK", c: "text-emerald-700", bg: "bg-emerald-500", p: 30 };

  const getLabel = (val) => {
    switch(val) {
      case 4: return "ÇOK SIK"; case 3: return "SIKLIKLA"; case 2: return "BAZEN"; case 1: return "NADİREN"; default: return "HİÇ";
    }
  };

  return (
    <div className="space-y-6 print:space-y-5 font-sans">
      {/* HEADER */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div>
          <h2 className="text-xl print:text-lg font-bold leading-none mb-1">ASRS DEHB Klinik Ön Tarama Raporu</h2>
          <span className="text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">{meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}</span>
        </div>
        <div className="bg-white/10 px-4 py-2 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl font-black block leading-none">{s.partA?.critical || 0}</span>
          <span className="text-[9px] block opacity-70 uppercase font-bold">Bölüm A Semptomu</span>
        </div>
      </div>

      {/* BAROMETRELER */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:gap-4">
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm">
             <div className="flex items-center mb-3 border-b border-slate-100 pb-2"><ShieldAlert className="h-5 w-5 text-red-500 mr-2"/><div><span className="text-sm font-black text-slate-800 uppercase tracking-widest block">BÖLÜM A (Ana Tarama)</span></div></div>
             <div className="flex justify-between mb-2"><span className={`text-sm font-black ${partAStatus.c}`}>{partAStatus.l}</span><span className="text-xs font-bold text-slate-400">{s.partA?.critical}/6 Semptom</span></div>
             <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1"><div className={`h-full ${partAStatus.bg}`} style={{ width: `${partAStatus.p}%` }}></div></div>
             <p className="text-[9px] text-slate-400 text-right">DSÖ Eşiği: 4 ve üzeri semptom Yüksek Risk göstergesidir.</p>
         </div>
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm">
             <div className="flex items-center mb-3 border-b border-slate-100 pb-2"><Activity className="h-5 w-5 text-indigo-500 mr-2"/><div><span className="text-sm font-black text-slate-800 uppercase tracking-widest block">BÖLÜM B (Semptom Sıklığı)</span></div></div>
             <div className="flex justify-between mb-2"><span className="text-sm font-black text-slate-700">EK SEMPTOMLAR</span><span className="text-xs font-bold text-slate-400">{s.partB?.critical}/12 Semptom</span></div>
             <p className="text-[10px] text-slate-500 mt-2 text-justify leading-relaxed">Bu bölümdeki yüksek bulgular, öğrencinin DEHB semptomlarını ne kadar geniş bir çerçevede ve sıklıkta yaşadığının kanıtıdır.</p>
         </div>
      </div>

      {/* EKSTRA KARTLAR: PDR GÖRÜŞME VE İŞLEVSELLİK */}
      {(s.focus?.length > 0 || s.impacts?.length > 0) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 print:gap-4 avoid-break">
            {s.focus?.length > 0 && (
                <div className="bg-blue-50 border border-blue-200 p-5 rounded-2xl print:bg-white print:border-slate-300">
                    <h3 className="font-bold text-blue-900 text-xs flex items-center mb-3 uppercase tracking-widest"><Lightbulb className="h-4 w-4 mr-2 text-blue-600"/> PDR Görüşme Odakları</h3>
                    <ul className="space-y-2">
                        {s.focus.map((item, i) => <li key={i} className="text-[11px] text-slate-700 font-medium flex items-start"><div className="h-1.5 w-1.5 rounded-full bg-blue-500 mt-1.5 mr-2 shrink-0"></div>{item}</li>)}
                    </ul>
                </div>
            )}
            {s.impacts?.length > 0 && (
                <div className="bg-emerald-50 border border-emerald-200 p-5 rounded-2xl print:bg-white print:border-slate-300">
                    <h3 className="font-bold text-emerald-900 text-xs flex items-center mb-3 uppercase tracking-widest"><Users className="h-4 w-4 mr-2 text-emerald-600"/> Olası Sosyal ve Akademik Etkiler</h3>
                    <ul className="space-y-2">
                        {s.impacts.map((item, i) => <li key={i} className="text-[11px] text-slate-700 font-medium flex items-start"><div className="h-1.5 w-1.5 rounded-full bg-emerald-500 mt-1.5 mr-2 shrink-0"></div>{item}</li>)}
                    </ul>
                </div>
            )}
        </div>
      )}

      {/* RİSKLİ MADDELER LİSTESİ */}
      <div className="bg-slate-50 p-5 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1 avoid-break">
        <h3 className="font-bold text-slate-800 mb-4 flex items-center text-sm border-b pb-3">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Klinik Sınırı Aşan İfadeler ({data.risks?.length || 0})
        </h3>
        {data.risks?.length > 0 ? (
          <div className="grid grid-cols-1 gap-3">
            {data.risks.map((item, i) => (
              <div key={i} className="flex items-start p-3 bg-white border border-red-200 rounded-xl shadow-sm">
                <div className="min-w-[24px] h-6 rounded flex items-center justify-center text-[10px] font-black mr-3 bg-slate-100 text-slate-500 border-slate-200">{item.id}</div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1">
                    <span className="block text-[8px] font-bold text-slate-400 uppercase tracking-wider">{item.id <= 6 ? "Bölüm A (Tarama)" : "Bölüm B (Detay)"}</span>
                    <span className="text-[8px] px-1.5 py-0.5 bg-red-100 text-red-700 rounded font-black tracking-widest uppercase">
                       {getLabel(item.score)}
                    </span>
                  </div>
                  <span className="text-[11px] text-slate-800 font-medium block">{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-slate-400 italic text-center py-4">Klinik sınırda işaretlenmiş madde bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
};